import { FC } from 'react'
import { FA_EXCLAMATION_CIRCLE } from 'const/icons'
import { IconProps } from './typing'
import { FormatIcon, formatIconName } from './subcomponents'

const Icon: FC<IconProps> = ({
  name,
  color,
  size: iconSize = '',
  right: marginRight = '',
  ...props
}) => {
  return (
    <FormatIcon
      icon={formatIconName(name)}
      alt=""
      role="img"
      color={color}
      marginRight={marginRight}
      fontSize={iconSize}
      {...props}
    />
  )
}

export const ErrorIcon: FC = () => (
  <Icon name={FA_EXCLAMATION_CIRCLE} right="5px" size="15px" color="error" />
)

export default Icon
